import { AnimationOnScroll } from 'react-animation-on-scroll';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';
import styles from './keto-font.module.css';
import { Container } from '../../components';

export default function KetoFont() {
  return (
    <section className={styles.font}>
      <Container>
        <AnimationOnScroll
          offset={400}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
          className={styles.font_inner}
        >
          <div className={styles.font_start}>
            <img src="/keto/font/font.svg" alt="fonts" />
          </div>
          <div className={styles.font_end}>
            <KetoTypography
              className={styles.font_title}
              tag="h2"
              variant={KetoTypographyVariant.HEADLINE_1}
            >
              About font
            </KetoTypography>
            <KetoPaper>
              <KetoTypography
                className={styles.font_text}
                tag="p"
                variant={KetoTypographyVariant.BODY_2}
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo
              </KetoTypography>
            </KetoPaper>
          </div>
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
